import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { PRODUCT_NAME } from '../../data/salesContent';
export function FinalCtaSection() {
  return <section className="border-t border-line bg-white px-5 py-20 md:py-28" data-id="element-109" data-mp="2ik130jqmf6x9">
      <div className="mx-auto max-w-3xl text-center" data-id="element-110" data-mp="2dibouv83qd4y">
        <h2 className="font-serif text-3xl uppercase leading-[1.15] text-ink md:text-5xl" data-id="element-111" data-mp="2dlprm4kogocx">
          Los primeros 90 días traen muchas novedades. <span className="text-rose-dark" data-id="element-112" data-mp="2mktap8juh3rf">Tené tus recursos organizados desde el comienzo.</span>
        </h2>
        <ProductImage className="mx-auto mt-12 w-full max-w-lg" data-id="element-113" data-mp="317wa5krq9mhe" />
        <p className="mt-10 font-serif text-xl uppercase text-ink md:text-2xl" data-id="element-114" data-mp="2wa4j0sywq4e9">{PRODUCT_NAME}</p>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-ink-muted" data-id="element-115" data-mp="3a9ckjsijlolm">
          Un sistema educativo y práctico para prepararte antes del nacimiento y acompañar los primeros tres meses de tu bebé.
        </p>
        <div className="mt-8 space-y-2" data-id="element-116" data-mp="221cougos0625">
          <p className="text-base font-bold uppercase tracking-[0.15em] text-honey-dark md:text-lg" data-id="element-117" data-mp="222e12ohj2ylg">5 volúmenes + 4 bonos</p>
          <p className="mx-auto max-w-2xl text-xs font-semibold uppercase leading-relaxed tracking-wider text-ink md:text-sm" data-id="element-118" data-mp="2b196hycr04np">
            Preparación + cuidados + alimentación + sueño + desarrollo + bienestar materno + organización
          </p>
        </div>
        <div className="mt-10 rounded-3xl border border-line bg-cream px-6 py-10 md:px-12" data-id="element-119" data-mp="2kyxa7dsc0mi0">
          <PriceBlock lead="Hoy por" data-id="element-120" data-mp="2ozh8wlsjzy69" />
          <div className="mt-8" data-id="element-121" data-mp="2trqujpmmyc2q">
            <CtaButton data-id="element-122" data-mp="2trh460xoi2wi">Quiero acceder al kit completo</CtaButton>
          </div>
        </div>
        <p className="mt-10 font-serif text-xl uppercase leading-snug text-ink md:text-2xl" data-id="element-123" data-mp="2yrdai6tum6f8">
          Más claridad para aprender. <span className="text-sage-dark" data-id="element-124" data-mp="33r7xw0ef0dvj">Más organización para el día a día.</span>
        </p>
        <p className="mx-auto mt-6 max-w-xl text-sm italic text-ink-muted" data-id="element-125" data-mp="38q2o3nepp4po">
          Material educativo. No reemplaza la consulta médica ni los controles pediátricos y maternos.
        </p>
      </div>
    </section>;
}